__turbopack_context__.v({
  "hiddenSpinner": "userProfileMenuLinks-module-scss-module__ZqvxMa__hiddenSpinner",
  "logoutLink": "userProfileMenuLinks-module-scss-module__ZqvxMa__logoutLink",
  "prefixIcon": "userProfileMenuLinks-module-scss-module__ZqvxMa__prefixIcon",
  "profileDropdownContent": "userProfileMenuLinks-module-scss-module__ZqvxMa__profileDropdownContent",
  "section": "userProfileMenuLinks-module-scss-module__ZqvxMa__section",
});
